import { createColumnHelper } from 'core/Hooks';
import { EmptyCell } from 'core/Packages';
import { Currency, Text } from 'ui';

import { useManagementTranslations } from '../../../../../../Context';
import { CrowdFundingAvatar } from '../../../../../components/CrowdFundingAvatar/CrowdFundingAvatar';
import { PeerActions } from './columnActions';
import { PeerTableType } from './peers.types';

const columnHelper = createColumnHelper<PeerTableType>();

const TeamNameHeader = () => {
  const { t } = useManagementTranslations();
  return <>{t('team')} Name</>;
};

export const teamColumns = [
  columnHelper.display({
    id: 'avatar',
    cell: (props) => (
      <CrowdFundingAvatar
        peerType="teams"
        isLoading={false}
        img={props.row.original.image?.url}
        name={props.row.original.name}
        size={32}
      />
    ),
    size: 40,
  }),
  columnHelper.accessor('name', {
    header: () => <TeamNameHeader />,
    cell: (props) => props.row.original.name,
  }),
  columnHelper.accessor('email', {
    header: 'Email Address',
    cell: (props) => props.row.original.email ?? <EmptyCell />,
  }),
  columnHelper.accessor('goal', {
    header: 'Fundraising Goal',
    cell: (props) =>
      props.row.original.goal ? (
        <Currency value={Number(props.row.original.goal)}>
          {(props) => <>${props.value}</>}
        </Currency>
      ) : (
        <EmptyCell />
      ),
    enableSorting: false,
  }),
  columnHelper.display({
    id: 'actions',
    cell: (props) => <PeerActions {...props} />,
    size: 40,
  }),
];

const TeamHeader = () => {
  const { t } = useManagementTranslations();
  return <>{t('team')} </>;
};

export const participantColumns = [
  columnHelper.accessor('first_name', {
    header: 'Name',
    cell: (props) => (
      <Text fz="xs" c="gray.6">
        {`${props.row.original.first_name} ${props.row.original.last_name}`}
      </Text>
    ),
  }),
  columnHelper.accessor('email', {
    header: 'Email Address',
    cell: (props) => props.row.original.email ?? <EmptyCell />,
  }),

  columnHelper.accessor('team.name', {
    header: () => <TeamHeader />,
    id: 'team.name',
    enableSorting: false,
    cell: (props) => props.row.original.team?.name ?? <EmptyCell />,
  }),
  columnHelper.display({
    id: 'actions',
    cell: (props) => <PeerActions {...props} />,
    size: 40,
  }),
];
